<template>
  <div>
    <el-dialog
      title="选择采购单行项目"
      :visible="show"
      width="1000px"
      @close="close"
    >
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="400px"
        v-loading="loading"
      >
        <el-table-column
          label="商品图片"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage
              :commodity="scope.row.commoditySnapshot"
              :commoditySpec="scope.row.commoditySpecSnapshot"
            ></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="commoditySnapshot.name"
          label="商品信息"
          min-width="150"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <span style="font-size: 1.1em">{{
                scope.row.commoditySnapshot.name
              }}</span
              ><br />
              {{ "规格：" + scope.row.commoditySpecSnapshot.specName }}<br />
              {{ "分类：" + scope.row.commoditySnapshot.commodityCategory.name
              }}<br />
              {{ "颜色：" + scope.row.commoditySnapshot.color }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityRetailTotalAmount"
          label="总采购价"
          width="120"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.commodityRetailTotalAmount"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="成交价"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <fm-amount :amount="scope.row.itemAmount"></fm-amount>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-document"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="选择采购单行项目"
      :visible="editItemPopupShow"
      width="600px"
      @close="editItemPopupShow = false"
      v-if="editItemPopupShow"
    >
      <el-row>
        <el-col :span="3">
          <CommodityImage
            :commodity="editItem.relatedPurchaseOrderItem.commoditySnapshot"
            :commoditySpec="
              editItem.relatedPurchaseOrderItem.commoditySpecSnapshot
            "
            size="60px"
          >
          </CommodityImage>
        </el-col>
        <el-col :span="20">
          <p>
            商品：<span style="font-weight: bold">{{
              editItem.relatedPurchaseOrderItem.commoditySnapshot.name
            }}</span>
          </p>
          <p>
            <span v-fmtype="''">规格：</span
            ><span v-fmtype="''" style="font-weight: bold">{{
              editItem.relatedPurchaseOrderItem.commoditySpecSnapshot.specName
            }}</span>
          </p>
          <p>
            <span v-fmtype="''">分类：</span
            ><span v-fmtype="''" style="font-weight: bold">{{
              editItem.relatedPurchaseOrderItem.commoditySnapshot
                .commodityCategory.name
            }}</span>
          </p>
          <p>
            <span v-fmtype="''">颜色：</span
            ><span v-fmtype="''" style="font-weight: bold">{{
              editItem.relatedPurchaseOrderItem.commoditySnapshot.color
            }}</span>
          </p>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="fm-flex">
        <el-col :span="12">
          <el-tooltip effect="dark" content="" placement="top-start">
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">当前库存说明</div>
              对应商品的最新库存数量
            </div>
            <i class="el-icon el-icon-question fm-mr-5"></i>
          </el-tooltip>
          <span>当前库存</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-skeleton
            animated
            :rows="1"
            v-if="
              !editItem.relatedPurchaseOrderItem.commoditySpec
            "
          >
            <template slot="template">
              <el-skeleton-item
                variant="rect"
                style="width: 240px; height: 80px"
              />
            </template>
          </el-skeleton>
          <div class="quantity_info" v-else>
            <div class="column">
              <div class="title">
                <div>可用库存</div>
                <div>待入库</div>
                <div>待出库</div>
                <div>报损中</div>
                <div>调拨中</div>
              </div>
              <div class="num">
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .availableQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .toBeInputQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .toBeOutputQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .lossingQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .transferQuantity
                  }}
                </div>
              </div>
            </div>
            <div class="column" style="margin: 0 10px 0 10px">
              <div class="num">
                <div>,</div>
                <div>,</div>
                <div>,</div>
                <div>,</div>
              </div>
            </div>
            <div class="column">
              <div class="title">
                <div>虚拟库存</div>
                <div>入库中</div>
                <div>出库中</div>
                <div>已报损</div>
              </div>
              <div class="num">
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .fictitiousQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .inputingQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .outputingQuantity
                  }}
                </div>
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.commoditySpec
                      .completedLossQuantity
                  }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="fm-flex">
        <el-col :span="12">
          <span>单位</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span>{{
              editItem.relatedPurchaseOrderItem.commoditySnapshot.unit
            }}</span>
          </p>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>采购价</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount
                :amount="editItem.relatedPurchaseOrderItem.retailPrice"
              ></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>购买数量</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span>{{ editItem.relatedPurchaseOrderItem.itemQuantity }}</span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="16">
          <el-tooltip effect="dark" content="" placement="top-start">
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">入库进度说明</div>
              所对应采购单行项目的最新入库进度
            </div>
            <i class="el-icon el-icon-question fm-mr-5"></i>
          </el-tooltip>
          <span>采购单入库进度</span>
        </el-col>
        <el-col :span="8">
          <div class="quantity_info">
            <div class="column">
              <div class="title">
                <div>待入库</div>
                <div>入库中</div>
                <div>退货中</div>
              </div>
              <div class="num">
                <div>
                  {{ editItem.relatedPurchaseOrderItem.toBeInputQuantity }}
                </div>
                <div>
                  {{ editItem.relatedPurchaseOrderItem.inputingQuantity }}
                </div>
                <div>
                  {{ editItem.relatedPurchaseOrderItem.returningQuantity }}
                </div>
              </div>
            </div>
            <div class="column" style="margin: 0 10px 0 10px">
              <div class="num">
                <div><br /></div>
                <div>,</div>
                <div>,</div>
              </div>
            </div>
            <div class="column">
              <div class="title">
                <div style="height: 19.2px"><br /></div>
                <div>已入库</div>
                <div>已退货</div>
              </div>
              <div class="num">
                <div><br /></div>
                <div>
                  {{ editItem.relatedPurchaseOrderItem.completedInputQuantity }}
                </div>
                <div>
                  {{
                    editItem.relatedPurchaseOrderItem.completedReturnQuantity
                  }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>总采购价</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount
                :amount="
                  editItem.relatedPurchaseOrderItem.commodityRetailTotalAmount
                "
              ></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>折扣金额</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount
                :amount="editItem.relatedPurchaseOrderItem.disCountAmount"
              ></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>成交价</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount
                :amount="editItem.relatedPurchaseOrderItem.itemAmount"
              ></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <template v-if="from == 'PurchaseReturnOrder'">
        <el-divider></el-divider>
        <el-row class="fm-flex">
          <el-col :span="12">
            <span>退货数量</span>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <p>
              <span>
                <CommodityQuantityInputBox
                  v-model="editItem.itemQuantity"
                  label="数量"
                  size="small"
                  :max="editItem.relatedPurchaseOrderItem.itemQuantity"
                  @change="
                    (e) => {
                      changeItemQuantityFromList(
                        e,
                        selectList.findIndex(
                          (d) => d.itemNo == editItem.itemNo
                        ),
                        true
                      );
                    }
                  "
                ></CommodityQuantityInputBox>
              </span>
            </p>
          </el-col>
        </el-row>
      </template>

      <template v-if="from == 'CommodityInputOrder'">
        <el-divider></el-divider>
        <el-row class="fm-flex">
          <el-col :span="12">
            <span>入库数量</span>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <p>
              <span>
                {{
                  editItem.itemQuantity > 0
                    ? "合计 " + editItem.itemQuantity
                    : "请选择仓库及填写出库数量"
                }}
              </span>
            </p>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-table
          :data="editItem.orderWareHouseAddNewPojoList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo;
            }
          "
          style="width: 100%"
          :key="'orderWareHouse' + orderWareHouseKey"
        >
          <el-table-column
            label="仓库"
            min-width="210"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  canSelectWareHouseListBySpec(
                    editItem.relatedPurchaseOrderItem.commoditySpec
                  ).length > 1
                "
              >
                <el-select
                  :value="scope.row.wareHouseId"
                  placeholder="请选择仓库"
                  @change="
                    (value) => selectWareHousePopupConfirm(value, scope.$index)
                  "
                >
                  <el-option
                    v-for="(item, index) in canSelectWareHouseListBySpec(
                      editItem.relatedPurchaseOrderItem.commoditySpec
                    )"
                    :key="item.wareHouseId + index"
                    :label="item.label"
                    :value="item.wareHouseId"
                  >
                    <span style="float: left">{{ item.label }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.desc }}</span
                    >
                  </el-option>
                </el-select>
              </template>
              <div style="text-align: left" v-else>
                <span>{{ scope.row.wareHouse.name }}</span>
              </div>
              <div style="text-align: left">
                <span v-if="scope.row.wareHouse">
                  {{ "虚拟库存 " + scope.row.fictitiousQuantity }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="入库数量"
            min-width="190"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                v-model="scope.row.itemQuantity"
                size="small"
                :max="editItem.relatedPurchaseOrderItem.toBeInputQuantity"
                style="width: 180px"
                @change="specWareHouseQuantityChange(scope.$index, scope.row)"
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            header-align="center"
            align="center"
            width="150"
            v-if="
              canSelectWareHouseListBySpec(
                editItem.relatedPurchaseOrderItem.commoditySpec
              ).length > 1
            "
          >
            <template slot-scope="scope">
              <el-button
                @click.native.stop="addSpecWareHouseItem(scope.$index)"
                type="text"
                icon="el-icon-plus"
                :disabled="
                  editItem.orderWareHouseAddNewPojoList.length ==
                  canSelectWareHouseListBySpec(
                    editItem.relatedPurchaseOrderItem.commoditySpec
                  ).length
                "
              >
                增加
              </el-button>
              <el-button
                type="text"
                icon="el-icon-delete"
                v-fmtype="
                  editItem.orderWareHouseAddNewPojoList.length == 1
                    ? 'info'
                    : 'error'
                "
                :disabled="editItem.orderWareHouseAddNewPojoList.length == 1"
                @click.native.stop="deleteSpecWareHouseItem(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editItemCancel">取 消</el-button>
        <el-button type="primary" @click="editItemConfirm"> 选 择 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebPurchaseOrderItemSelectDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      //  来源，PurchaseReturnOrder 采购退货单 | CommodityInputOrder 入库单
      type: String,
      default: null,
      require: true,
    },
    supplierId: {
      type: String,
      default: null,
      require: true,
    },
    purchaseOrderId: {
      type: String,
      default: null,
      require: true,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.orderWareHouseKey = this.$options.data().orderWareHouseKey;
        this.getOrderInfo();
        this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
        this.getCanSelectWareHouseList();
      },
      immediate: true,
    },
  },
  data() {
    return {
      // 来源，PurchaseReturnOrder 采购退货单 | CommodityInputOrder 入库单
      //   from: null,

      //   purchaseOrderId: null,
      loading: false,

      editItemPopupShow: false,
      // 当前选择的item
      editItem: {},

      // 显示已选商品弹窗
      showSelectListPopup: false,
      // 已选的商品 成型数据
      //   selectList: [],

      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        supplierId: null,
        saleUserIdList: [],
        commodityRetailTotalAmount: "0.00",
        disCountAmount: "0.00",
        orderAmount: "0.00",
        totalQuantity: 0,
      },
      itemList: [],

      selectWareHousePopupShow: false,
      orderWareHouseKey: "null",
      selectWareHousePopupIndex: -1,
      wareHouseList: [],

      quantityMinLimit: 0.001,
    };
  },
  methods: {
    async getCanSelectWareHouseList(args) {
      let res = await this.$api.wareHouse_findListForSelect(args);
      if (res && res.success) {
        this.canSelectWareHouseList = res.data;
      }
    },
    canSelectWareHouseListBySpec(commoditySpec) {
      let res = commoditySpec.commoditySpecWareHouseList.map((d) => {
        return {
          label: d.wareHouse.name,
          wareHouse: d.wareHouse,
          wareHouseId: d.wareHouseId,
          fictitiousQuantity: d.fictitiousQuantity,
          availableQuantity: d.availableQuantity,
          desc: "虚拟库存 " + d.fictitiousQuantity,
        };
      });
      let oldIdList = res.map((d) => d.wareHouseId);
      if (
        this.canSelectWareHouseList &&
        this.canSelectWareHouseList.length > 0
      ) {
        res = res.concat(
          this.canSelectWareHouseList
            .filter((d) => oldIdList.indexOf(d.id) < 0)
            .map((d) => {
              return {
                label: d.name,
                wareHouse: d,
                wareHouseId: d.id,
                fictitiousQuantity: 0,
                availableQuantity: 0,
                desc: "该仓库中没有此规格",
              };
            })
        );
      }
      return res;
    },
    // 选择仓库
    showSelectWareHousePopup(index) {
      this.wareHouseList = this.canSelectWareHouseListBySpec(
        this.editItem.relatedPurchaseOrderItem.commoditySpec
      );
      this.selectWareHousePopupIndex = index;
      this.selectWareHousePopupShow = true;
    },
    selectWareHousePopupConfirm(item, selectWareHousePopupIndex) {
      if (item) {
        let selectIndex = this.editItem.orderWareHouseAddNewPojoList.findIndex(
          (d) => d.wareHouseId && d.wareHouseId == item
        );
        if (selectIndex > -1) {
          this.$message.error("请勿重复选择仓库");
          this.selectWareHousePopupShow = false;
          return;
        }
        let data = this.canSelectWareHouseListBySpec(
          this.editItem.relatedPurchaseOrderItem.commoditySpec
        ).filter((d) => d.wareHouseId && d.wareHouseId == item)[0];
        this.editItem.orderWareHouseAddNewPojoList.splice(
          selectWareHousePopupIndex,
          1,
          {
            ...this.editItem.orderWareHouseAddNewPojoList[
              selectWareHousePopupIndex
            ],
            wareHouse: data.wareHouse,
            wareHouseId: data.wareHouseId,
            fictitiousQuantity: data.fictitiousQuantity,
            availableQuantity: data.availableQuantity,
          }
        );
        this.orderWareHouseKey = Math.random();
        this.selectWareHousePopupShow = false;
      }
    },
    specWareHouseQuantityChange() {
      let quantity = Number(
        this.$jsTool.sumQuantity(
          this.editItem.orderWareHouseAddNewPojoList.map(
            (d) => d.itemQuantity || 0
          )
        )
      );
      this.editItem.itemQuantity = quantity;
    },
    addSpecWareHouseItem(index) {
      this.editItem.orderWareHouseAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.editItem.orderWareHouseAddNewPojoList[
            this.editItem.orderWareHouseAddNewPojoList.length - 1
          ].itemNo + 1,
        itemQuantity: 1,
      });
      this.orderWareHouseKey = Math.random();
      this.specWareHouseQuantityChange();
    },
    deleteSpecWareHouseItem(index) {
      let that = this;
      this.$confirm("确认删除所选仓库信息？", "操作提醒", {
        confirmButtonText: "继续删除",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      })
        .then(() => {
          that.editItem.orderWareHouseAddNewPojoList.splice(index, 1);
          this.orderWareHouseKey = Math.random();
          that.specWareHouseQuantityChange();
        })
        .catch(() => {});
    },
    showEditSpecPopup(item, index) {
      if (!this.from == "CommodityInputOrder") {
        return;
      }
      this.editItem = JSON.parse(JSON.stringify(item));
      this.editItemPopupShow = true;
    },

    close() {
      this.$emit("close");
    },
    // PurchaseReturnOrder | CommodityInputOrder
    async select(item) {
      if (this.from == "PurchaseReturnOrder") {
        if (
          item.itemQuantity ==
          item.returningQuantity + item.completedReturnQuantity
        ) {
          this.$message.error(
            "所选采购单行项目可退货数量为 0 ，请选择其他行项目"
          );
          return;
        }
      } else if (this.from == "CommodityInputOrder") {
        if (item.toBeInputQuantity == 0) {
          this.$message.error(
            "所选采购单行项目待入库数量为 0 ，请选择其他行项目"
          );
          return;
        }
      }
      let index =
        this.from == "CommodityInputOrder"
          ? this.selectList.findIndex((d) => d.relatedOrderItemId == item.id)
          : this.selectList.findIndex(
              (d) => d.relatedPurchaseOrderItemId == item.id
            );
      if (index > -1) {
        this.editItem = JSON.parse(JSON.stringify(this.selectList[index]));
      } else {
        let itemNo =
          this.selectList && this.selectList.length > 0
            ? this.selectList[this.selectList.length - 1].itemNo + 1
            : 1;
        this.editItem = {
          itemNo: itemNo,
          relatedOrderItemId: item.id,
          relatedPurchaseOrderItem: item,
          relatedPurchaseOrderItemId: item.id,
          itemQuantity: 1,
          commodityRetailTotalAmount: this.$jsTool.multi(item.retailPrice, 1),
        };
        // 获取商品信息
        let getCommoditySpecRes = await this.$api.commoditySpec_findById(
          item.commoditySpecId,
          {
            showLoading: true,
            loadingParam: {
              target: "#quantity_info",
              lock: true,
              text: "导出中...",
            },
          }
        );
        if (getCommoditySpecRes && getCommoditySpecRes.success) {
          this.editItem.relatedPurchaseOrderItem.commoditySpec =
            getCommoditySpecRes.data;
        }
        if (this.from == "CommodityInputOrder") {
          // 只有一个则默认选择
          let canSelectWareHouseListBySpec = this.canSelectWareHouseListBySpec(
            this.editItem.relatedPurchaseOrderItem.commoditySpec
          );
          let specWareHouse =
            canSelectWareHouseListBySpec.length == 1
              ? canSelectWareHouseListBySpec[0]
              : {};
          this.editItem.orderWareHouseAddNewPojoList = [
            {
              itemNo: 1,
              wareHouse: specWareHouse.wareHouse || null,
              wareHouseId: specWareHouse.wareHouseId || null,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.availableQuantity || 0,
              itemQuantity: 1,
            },
          ];
        }
      }
      this.editItemPopupShow = true;
    },
    editItemCancel() {
      this.editItemPopupShow = false;
      this.editItem = {};
    },
    editItemConfirm() {
      if (!this.editItem || !this.editItem.itemNo) {
        this.$message.error("请选择商品");
        return;
      }
      if (!this.editItem.itemQuantity) {
        this.$message.error("请输入数量");
        return;
      }
      this.loading = true;
      try {
        let index =
          this.from == "CommodityInputOrder"
            ? this.selectList.findIndex(
                (d) => d.relatedOrderItemId == this.editItem.relatedOrderItemId
              )
            : this.selectList.findIndex(
                (d) =>
                  d.relatedPurchaseOrderItemId ==
                  this.editItem.relatedPurchaseOrderItemId
              );
        let itemAmount = this.$jsTool.multi(
          this.editItem.relatedPurchaseOrderItem.retailPrice,
          this.editItem.itemQuantity
        );
        let item = {
          ...this.editItem,
          commodityRetailTotalAmount: itemAmount,
        };
        if (this.from == "CommodityInputOrder") {
          if (
            this.editItem.orderWareHouseAddNewPojoList.some(
              (item) => !item.wareHouseId
            )
          ) {
            this.$message({
              message: "请选择仓库后重试！",
              type: "error",
            });
            return;
          }
          let quantity = Number(
            this.$jsTool.sumQuantity(
              this.editItem.orderWareHouseAddNewPojoList.map(
                (d) => d.itemQuantity || 0
              )
            )
          );
          if (
            quantity > this.editItem.relatedPurchaseOrderItem.toBeInputQuantity
          ) {
            this.$message({
              message:
                "入库总数量不得大于所选商品的待入库数量" +
                this.editItem.relatedPurchaseOrderItem.toBeInputQuantity,
              type: "error",
            });
            return;
          }
          item.orderWareHouseAddNewPojoList =
            this.editItem.orderWareHouseAddNewPojoList;
        }
        if (index > -1) {
          this.selectList.splice(index, 1, item);
        } else {
          this.selectList.push(item);
        }
        this.editItemPopupShow = false;
        this.$emit("selectPurchaseOrderItem", this.selectList || []);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (!this.editItemPopupShow) {
          this.$emit("close");
        }
      }
    },
    changeItemQuantityFromList(value, index) {
      // 如果index < 0，则代表是新商品，无需进行处理
      if (index < 0) {
        return;
      }
      if (value <= 0) {
        let that = this;
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            try {
              this.editItem = {};
              this.editItemPopupShow = false;
              this.selectList.splice(index, 1);
              this.$emit("selectPurchaseOrderItem", this.selectList || []);
            } finally {
              if (!this.editItemPopupShow) {
                this.$emit("close");
              }
            }
          })
          .catch(() => {
            this.editItem.itemQuantity = this.quantityMinLimit;
          });
      }
    },
    //   changeItemQuantityFromSeeMore({ value }, index) {
    //     if (value <= 0) {
    //       let that = this;
    //       this.$showModal({
    //         title: "操作提醒",
    //         content: "是否移除所选商品?",
    //         confirmText: "移除",
    //         confirmColor: "error",
    //         success: (res) => {
    //           if (res.confirm) {
    //             that.selectList.splice(index, 1);
    //           } else {
    //             that.selectList[index].itemQuantity = 1;
    //             that.$refs.quantityBox[index].init();
    //             that.$forceUpdate();
    //           }
    //         },
    //       });
    //     } else {
    //       let commoditySpec =
    //         this.selectList[index].relatedPurchaseOrderItem.commoditySpecSnapshot;
    //       let retailPrice =
    //         this.selectList[index].relatedPurchaseOrderItem.retailPrice;
    //       let itemAmount = this.$tool.multi(retailPrice, value);
    //       let item = {
    //         ...this.selectList[index],
    //         itemQuantity: value,
    //         commodityRetailTotalAmount: itemAmount,
    //       };
    //       this.selectList.splice(index, 1, item);
    //     }
    //   },
    //   // 确认选择
    //   confirmSelect() {
    //     let that = this;
    //     this.$showModal({
    //       title: "操作提醒",
    //       content:
    //         !that.selectList || that.selectList.length == 0
    //           ? "尚未选择商品，继续确认将会移除单据中原已选择的商品，是否继续？"
    //           : "是否选择完成？",
    //       confirmText:
    //         !that.selectList || that.selectList.length == 0
    //           ? "继续确认"
    //           : "选择完成",
    //       confirmColor:
    //         !that.selectList || that.selectList.length == 0 ? "warning" : "primary",
    //       success: (res) => {
    //         if (res.confirm) {
    //           let pages = getCurrentPages();
    //           let beforePage = pages[pages.length - 2];
    //           uni.navigateBack({
    //             success: function () {
    //               beforePage.$vm.selectPurchaseOrderItem(that.selectList || []);
    //             },
    //           });
    //         }
    //       },
    //     });
    //   },
    async getOrderInfo(args) {
      this.loading = true;
      let res = await this.$api.purchaseOrder_findVoById(
        this.purchaseOrderId,
        args
      );
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          saleUserIdList: res.data.head.saleUserList.map((d) => d.userId),
        };
        this.itemList = res.data.itemList;
      }
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
/* 解决分割线存在粗细不一致异常 */
.el-divider {
  background-color: transparent;
  position: relative;
}

.el-divider--horizontal {
  height: 0;
  border-bottom: 1px solid #dcdfe6;
}
</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrderItemSelectDialog.vue